import {LandOwnerType} from './landOwnerType';

export class JurisdictionalAgency {
  jurisdictionalAgencyId: number;
  shortName: string;
  longName: string;
  fedEmailRequired: boolean;
  isFlameAct: boolean;
  landOwnerType: "FEDERAL" | "OTHER ";
  constructor(jurisdictionalAgency: JurisdictionalAgency) {
    this.jurisdictionalAgencyId = jurisdictionalAgency.jurisdictionalAgencyId;
    this.shortName = jurisdictionalAgency.shortName;
    this.longName = jurisdictionalAgency.longName;
    this.fedEmailRequired = jurisdictionalAgency.fedEmailRequired;
    this.isFlameAct = jurisdictionalAgency.isFlameAct;
    this.landOwnerType = jurisdictionalAgency.landOwnerType;
  }


}
